import { gql } from "@apollo/client";

export const InstalledBaseRootNodeList = gql`
    query InstalledBaseRootNodeList($search: SearchInput, $filter: InstalledBaseNodeListFilter, $pagination: Pagination, $sort: InstalledBaseNodeListSort) {
        installedBaseRootNodeList(filter: $filter, search: $search) {
            total
            installedBaseNodes (pagination: $pagination, sort: $sort) {
                id
                key
                title
                isStarred
                assetCount
                childrenNodeCount
                owner {
                    id
                    name
                }
                access {
                    id
                    read
                    write
                    delete
                }
                nodeType {
                    id
                    key
                    name
                }
                parentNode {
                    key
                    id
                    title
                    nodeType {
                        id
                        key
                        name
                    }
                }
                assetLocation {
                    id
                    asset {
                        id
                        serialNumber
                    }
                }
                keyPath
            }
        }
    }
`;
